import React, { Component, createContext } from "react";
import { BrowserRouter, Routes, Route, useLocation  } from "react-router-dom";

import Cookies from "js-cookie";

import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "./utils/ScrollToTop";

import "bootstrap/js/src/collapse";

import requester from "./library/Requester"; 

import * as util from './library/utilitys';

import ReactGA from "react-ga4";

export const CsrfContext = createContext();

const TRACKING_ID = process.env.REACT_APP_GA_TAG;
ReactGA.initialize(TRACKING_ID);

function GAListener() {
    const location = useLocation();

    React.useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname + location.search,
            title: document.title,
        });
        console.log("📊 GA PageView:", location.pathname);
    }, [location]);

    return null;
}

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            csrfToken: localStorage.getItem("csrfToken") || null,
            authToken: localStorage.getItem("authToken") || null,
            userProfile: Cookies.get("userProfile") ? JSON.parse(Cookies.get("userProfile")) : null,
            error: null,
        };
    }

    componentDidMount() {
        this.initializeAuth();
        ReactGA.send({
            hitType: "pageview",
            page: window.location.pathname + window.location.search,
            title: document.title,
        });
    }

    initializeAuth = () => {
        // if (!this.state.csrfToken) {
        //     this.getCsrfToken();
        // }
        // else if (!this.state.authToken) {
        //     this.getLoginToken();
        // }
    };

    getCsrfToken = () => {
        requester.get("/public/csrf-token")
            .then((response) => {
                const csrfToken = response.data.csrfToken;
                localStorage.setItem("csrfToken", csrfToken);
                this.setState({ csrfToken }, () => {
                    this.getLoginToken(); 
                }, () => { 
                    util.debug(this.state, 'GET-CSRF-TOKEN-SUCCESS', this.state.csrfToken); 
                });
            })
            .catch((error) => {
                console.error("Error fetching CSRF Token", error);
                this.setState({ error: "Failed to fetch CSRF token" }, () => {
                    util.debug(this.state, 'GET-CSRF-TOKEN-SUCCESS-FAIL'); 
                });
            });
    };

    getLoginToken = () => {
        requester.post("/login", {username: "admin", password: "password"}, {
            headers: { "X-CSRF-Token": this.state.csrfToken }
        })
        .then((response) => {
            const { token, user } = response.data;

            localStorage.setItem("authToken", token);

            // console.log("===========", token, user);

            Cookies.set("userProfile", JSON.stringify(user), {
                expires: process.env.REACT_APP_COOKIE_AGE,
                secure: process.env.REACT_APP_ENV_MODE === "production",
                sameSite: "Lax"
            });

            this.setState({ authToken: token, userProfile: user }, () => {
                util.debug(this.state, 'GET-TOKEN-AND-USER-PROCESS-SUCCESS')
            });
        })
        .catch((error) => {
            this.setState({ error: "Failed to fetch login token" }, () => {
                util.debug(this.state, 'GET-TOKEN-AND-USER-PROCESS-FAIL')
            });
        });
    };

    render() {
        return (
            <CsrfContext.Provider value={this.state.csrfToken}>
                <BrowserRouter>
                    <ScrollToTop>
                        <Routes>
                            <Route path="/*" element={<AppRoutes />} />
                        </Routes>
                    </ScrollToTop>
                </BrowserRouter>
            </CsrfContext.Provider>
        );
    }
}

export default App;
